// Mapping of tipo to the corresponding field name
const fieldMapping = {
    banco: 'banco',
    cuenta: 'tipo_cuenta',
    tipo_flota: 'tipo_flota',
    tipo_vehiculo: 'vehiculo',
    tms: 'tms',
    centro_despacho: 'centro'
};

export const jsonConfiguration = (tipo, data) => {
    let jsonData = {};
    if (tipo === 'empresa') {
        jsonData = {
            tipo: tipo,
            dato: {
                razonSocial: data.razonSocial,
                rut: data.rut,
                sigla: data.sigla,
                contactoComercial: data.contactoComercial,
                telefonoComercial: data.telefonoComercial,
                emailComercial: data.emailComercial,
                jefeFota: data.jefeFota || '',
                telefonoJf: data.telefonoJf || '',
                emailJf: data.emailJf || '',
                dato_bancario: {
                    banco_id: data.banco.id,
                    tipo_cuenta_id: data.tipo_cuenta.id,
                    numeroCuenta: data.numero_cuenta
                },
                documento: {
                    id: data.documento.id,
                    documento: data.documento.nombre
                }
            }
        };
    } else if (tipo === 'conductor') {
        jsonData = {
            tipo: tipo,
            dato: {
                nombre: data.nombre,
                apellido: data.apellido,
                rut: data.rut,
                telefono: data.telefono,
                email: data.email,
                empresa: {
                    id: data.empresa.id,
                    sigla: data.empresa.nombre,
                },
                tms: {
                    id: data.tms.id,
                    tms: data.tms.nombre,
                },
                cd: {
                    id: data.centro_despacho.id,
                    dentroDespacho: data.centro_despacho.nombre,
                },
                tipo_flota: {
                    id: data.tipo_flota.id,
                    flota: data.tipo_flota.nombre,
                },
                vehiculo: {
                    tipo_vehiculo_id: data.tipo_vehiculo.id,
                    ppu: data.ppu,
                    marca: data.marca,
                    modelo: data.modelo,
                    anio: data.año,
                },
                datos_bancarios: {
                    banco_id: data.banco.id,
                    tipo_cuenta_id: data.tipo_cuenta.id,
                    numero_cuenta: data.numero_cuenta,
                    tipo_documento_id: data.tipo_documento.id,
                }
            }
        }
    } else if (['banco', 'cuenta', 'tipo_flota', 'tipo_vehiculo', 'tms', 'centro_despacho'].includes(tipo)) {
        const fieldName = fieldMapping[tipo];
        jsonData = {
            tipo: tipo,
            dato: {
                nombre: data[fieldName]
            }
        };
    } else if (tipo == 'tipo_documento') {
        jsonData = {
            tipo: tipo,
            dato: {
                nombre: data.tipo_documento,
                impuesto: data.impuesto
            }
        };
    } else if (['bono', 'descuento'].includes(tipo)) {
        jsonData = {
            tipo: tipo,
            dato: {
                nombre: data.nombre,
                monto: data.monto
            }
        }
    } else if (tipo == 'vehiculo') {
        jsonData = {
            tipo: tipo,
            dato: {
                ppu: data.ppu,
                marca: data.marca,
                modelo: data.modelo,
                anio: data.año,
                tipo_vehiculo: {
                    id: data.tipo_vehiculo.id,
                    tipo: data.tipo_vehiculo.nombre
                }
            }
        }
    } else if (tipo == 'cierre') {
        jsonData = {
            tipo: tipo,
            dato: {
                fechaInicio: data.fecha_inicio,
                fechaFin: data.fecha_fin,
            }
        }
    } else {
        console.log('Tipo no encontrado: ', tipo);
    }
    return jsonData;
}

// const jsonData = {
//     tipo: tipo,
//     dato: {
//         razonSocial: data.razonSocial,
//         rut: data.rut,
//         sigla: data.sigla,
//         contactoComercial: data.contactoComercial,
//         telefonoComercial: data.telefonoComercial,
//         emailComercial: data.emailComercial,
//         jefeFota: data.jefeFota || '',
//         telefonoJf: data.telefonoJf || '',
//         emailJf: data.emailJf || '',
//         dato_bancario: {
//             banco_id: data.banco.id,
//             tipo_cuenta_id: data.tipo_cuenta.id,
//             numeroCuenta: data.numero_cuenta
//         },
//         documento: {
//             id: data.documento.id,
//             documento: data.documento.nombre
//         }
//     }
// };